import PayOrderDataStore from '../../datastores/PayOrderDataStore';

export default class PayOrderDataStoreMock implements PayOrderDataStore {
  async register() {
    const data = {
      message: 'success'
    };
    return data;
  }
}
